/* eslint-disable max-len,no-irregular-whitespace,no-console */
import React from 'react';
import Layout from '../../components/Layout';
import DrWatsonLargeLogo from '../../components/DrWatsonLargeLogo';
import SEO from '../../components/seo';
import NavBar from '../../components/NavBar';
import Footer from '../../components/Footer';
import './style.scss';
import getCloudinary from '../../utils/getCloudinary';

const DrWatsonCBDPage = () => (
    <Layout id="dr-watson-cbd-page">
        <SEO title="DR WATSON CBD" />
        <DrWatsonLargeLogo />
        <NavBar />

        <div className="nav-bar-below-content">
            <div className="is-size-5-touch is-size-4-desktop">
                <div
                    className="is-size-5-touch is-size-4-desktop has-text-white non-image-text"
                    style={{
                        backgroundImage: `url("${getCloudinary().url(
                            'dashboard-uploads/bottles-factory-shot_ncif7p.jpg',
                            { height: 2000, crop: 'fit', fetch_format: 'auto' },
                        )}")`,
                    }}
                >

                    <div className="image-dimmer" />

                    <div className="is-size-6-touch is-size-5-desktop has-text-white non-image-text__text">

                        DR WATSON is a global hemp and CBD company and the exclusive producer of DR WATSON CBD products.
                        <br />
                        <br />
                        We exist to be the most trusted and respected cannabis brand in the world. Working with Chief
                        Scientist Dr Richard Watson PhD at DR WATSON we have developed the highest quality CBD products
                        you can buy.
                        <br />
                        <br />
                        <strong className="is-size-6-touch is-size-5-desktop has-text-white">
                            Our mission is not to just raise the standard for the industry, but to set it - by
                            being the world leader in quality, consistency and traceability from seed to shelf.
                        </strong>
                        <br />
                        <br />
                        Following Dr Richard Watson’s stringent specifications, all of our materials and products are
                        manufactured in facilities with ISO accreditations / GMP certification. And we only ever
                        use the highest quality ingredients, from our GMP-certified CBD to our Swiss made 100% vegan
                        luxe facial cream. While we are driven to exceed expectations on quality standards, we also care
                        about the environment and contribute to sustainability.
                    </div>
                </div>

                <div className="columns image-text-row is-marginless">
                    <div className="column is-paddingless">

                        <div className="image-with-text-overlay">
                            <img
                                src={
                                    getCloudinary().url(
                                        'dashboard-uploads/richard-farm_wyebb1',
                                        { height: 625, crop: 'fit', fetch_format: 'auto' },
                                    )
                                }
                                alt="Dr Richard Watson Farm"
                            />
                            <div className="title has-text-white is-size-3-touch is-size-2-desktop">
                                [ The Scientist ]
                            </div>
                        </div>

                    </div>
                    <div className="column main-content">
                        <div className="is-size-6-touch is-size-5-desktop">
                            Dr Richard Watson is a New Zealand-born American
                            biotechnology scientist and agricultural researcher who
                            has spent the last 20 years researching, developing, and
                            operating sustainable agricultural methods in the Georgia
                            Coastal Plain, USA, where he owns over 4000 acres of
                            irrigated farmland and oversees the cultivation of several
                            crops, including Cannabis Sativa L. / Industrial Hemp.
                            <br />
                            <br />
                            Richard works closely with the USA state and federal
                            regulators, and has directed research programs at leading
                            US universities, including the University of Georgia.
                            <br />
                            <br />
                            Specialising in grass science he is the only farmer in the
                            USA producing “certified humane” dairy products and
                            pioneered the grass fed 365 dairy model in the US.
                            <br />
                            <br />
                            DR WATSON, the brand and the scientist, believe in setting
                            the standard when it comes to sustainable agriculture
                            and product quality
                        </div>
                    </div>
                </div>

                <div className="container terpenes-text">
                    <div className="title is-size-3-touch is-size-2-desktop is-spaced">Terpenes</div>
                    <div className="is-size-6-touch is-size-5-desktop">
                        Terpenes are organic hydrocarbons that are found in
                        hundreds of plants around the world, and they are a
                        source of a plant’s aroma and flavour. Terpenes are one
                        way plants can defend themselves from predators. By
                        excreting a pungent aroma, plants can repel certain bugs
                        but can also attract the beneficial insects that they need
                        for pollination.
                        Today, we have discovered about 100 different terpenes
                        in cannabis. Each particular strain has its unique types
                        and combination of terpenes in various concentrations.
                        Terpenes work synergistically with cannabinoids. One
                        indication for this is that some cannabis strains may have
                        the exact same levels of THC and CBD, yet their effects can
                        be quite different. Researchers are now discovering that
                        terpenes have a direct link to the efficacy of cannabinoids.
                    </div>
                    <br />
                    <div className="title is-size-4-touch is-size-3-desktop is-spaced">
Terpenes Used In Our Products
                    </div>
                    <div>
                        <table className="table is-bordered is-striped is-hoverable is-fullwidth">
                            <thead>
                                <tr>
                                    <th className="is-size-6-touch is-size-5-desktop">Name</th>
                                    <th className="is-size-6-touch is-size-5-desktop">Characteristics</th>
                                    {/* <th className="is-size-6-touch is-size-5-desktop">Associated With</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th className="is-size-6-touch is-size-5-desktop">A-Pinene</th>
                                    <td className="is-size-6-touch is-size-5-desktop">
                                    Sharp, sweet and pine
                                    </td>
                                    {/* <td className="is-size-6-touch is-size-5-desktop"> */}
                                    {/* Memory boost, asthma and improves */}
                                    {/* concentration */}
                                    {/* </td> */}
                                </tr>

                                <tr>
                                    <th className="is-size-6-touch is-size-5-desktop">B-Pinene</th>
                                    <td className="is-size-6-touch is-size-5-desktop">
                                    Sharp, sweet and pine
                                    </td>
                                    {/* <td className="is-size-6-touch is-size-5-desktop"> */}
                                    {/* A bronchodilator and improves concentration */}
                                    {/* </td> */}
                                </tr>

                                <tr>
                                    <th className="is-size-6-touch is-size-5-desktop">Beta Caryophyllene</th>
                                    <td className="is-size-6-touch is-size-5-desktop">
                                    Black pepper and spice
                                    </td>
                                    {/* <td className="is-size-6-touch is-size-5-desktop"> */}
                                    {/* Anti-inflammatory, analgesic, prevents plaque */}
                                    {/* build-up in arteries and relief from toothache */}
                                    {/* </td> */}
                                </tr>

                                <tr>
                                    <th className="is-size-6-touch is-size-5-desktop">Diene</th>
                                    <td className="is-size-6-touch is-size-5-desktop">
                                    Organic alcohol
                                    </td>
                                    {/* <td className="is-size-6-touch is-size-5-desktop"> */}
                                    {/* Anti-microbial */}
                                    {/* </td> */}
                                </tr>
                                <tr>
                                    <th className="is-size-6-touch is-size-5-desktop">Dimethyl octi dienol</th>
                                    <td className="is-size-6-touch is-size-5-desktop">
                                    Organic tertiary alcohol.
                                    Found in brewer’s yeast and alcohol
                                    </td>
                                    {/* <td className="is-size-6-touch is-size-5-desktop"> */}
                                    {/* An emulsifier */}
                                    {/* </td> */}
                                </tr>
                                <tr>
                                    <th className="is-size-6-touch is-size-5-desktop">Geraniol</th>
                                    <td className="is-size-6-touch is-size-5-desktop">
                                    Fruity, floral, sweet and citrusy.
                                    Found in roses and geraniums
                                    </td>
                                    {/* <td className="is-size-6-touch is-size-5-desktop"> */}
                                    {/* Anti-tumor/anti-cancer properties and */}
                                    {/* chemoprotective */}
                                    {/* </td> */}
                                </tr>
                                <tr>
                                    <th className="is-size-6-touch is-size-5-desktop">Limonene</th>
                                    <td className="is-size-6-touch is-size-5-desktop">
                                    Citrus, lemon and orange
                                    </td>
                                    {/* <td className="is-size-6-touch is-size-5-desktop"> */}
                                    {/* Gastric reflux, antifungal and anti-anxiety */}
                                    {/* </td> */}
                                </tr>
                                <tr>
                                    <th className="is-size-6-touch is-size-5-desktop">Linalool</th>
                                    <td className="is-size-6-touch is-size-5-desktop">
                                    Floral, citrus, spice, cedarwood and
                                    lavender.
                                    </td>
                                    {/* <td className="is-size-6-touch is-size-5-desktop"> */}
                                    {/* Sedating, calming, insomnia, anxiety, */}
                                    {/* convulsions and hygiene */}
                                    {/* </td> */}
                                </tr>
                                <tr>
                                    <th className="is-size-6-touch is-size-5-desktop">Mentha</th>
                                    <td className="is-size-6-touch is-size-5-desktop">
                                    Fresh, cool mint
                                    </td>
                                    {/* <td className="is-size-6-touch is-size-5-desktop"> */}
                                    {/* Stomach pains, dental pain, irritable bowel */}
                                    {/* syndrome, and alleviating stress and anxiety */}
                                    {/* </td> */}
                                </tr>
                                <tr>
                                    <th className="is-size-6-touch is-size-5-desktop">Myrcene</th>
                                    <td className="is-size-6-touch is-size-5-desktop">
                                    Musk, cloves, herbal and citrus
                                    </td>
                                    {/* <td className="is-size-6-touch is-size-5-desktop"> */}
                                    {/* Antiseptic, antibacterial, antifungal, relaxant */}
                                    {/* and anti-inflammatory */}
                                    {/* </td> */}
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <Footer />

    </Layout>
);

export default DrWatsonCBDPage;
